// extracted by mini-css-extract-plugin
export default {"container":"collapsible-fitment-page-banner__container___3rafH","fitment-banner":"collapsible-fitment-page-banner__fitment-banner___yyjqC"};